import { aoApiFetchClient } from "@lending/lib/api";

// These account-opening verification endpoints are served by ao_api under
// /v2/account_opening. They are unauthenticated server-side (no session auth),
// so there is no CSRF to attach — hence the plain typed aoApiFetchClient rather
// than the CSRF-aware useAoApi() client.

async function locateApplicant(email: string) {
  const { response, data } = await aoApiFetchClient.POST(
    "/v2/account_opening/consumer/verification_code/locate_applicant/",
    { body: { email } }
  );

  return {
    response,
    data: data ?? null,
  };
}

async function verifyApplicantCode(email: string, code: string) {
  const { response } = await aoApiFetchClient.POST(
    "/v2/account_opening/consumer/verification_code/verify/",
    { body: { email, code } }
  );

  return response;
}

export { locateApplicant, verifyApplicantCode };
